<template>
  <lk-spin fix  :class = "loadZIndex ? 'loadSpin' : '' ">
    <lk-icon custom="iconfont i-icon-loading" size=36 class="demo-spin-icon-load"></lk-icon>
  </lk-spin>
</template>
<script>
export default {
  name: 'loadingSpin',
  props: {
    loadZIndex: { // loadingSpan组件层级
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
  .loadSpin {
    z-index: 4100;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 2s linear infinite;
  }
  .i-icon-loading{
    color: #444;
  }
  .i-icon-loading:before {
    content: "\e634";
  }
</style>
